export default class Utils {

  /**
   * Takes a time in seconds and converts it to timecode.
   *
   * @param   {Number}  time  The time in seconds to be formatted.
   * @return  {String}  A SMTP formatted string.
   */
  static formatTimecode(time, duration) {
    time = parseInt(time)
    if (isNaN(time)) {
      return "00:00"
    }
    var strTime = Utils.formatZeroFill(time % 60)
    time = parseInt(time / 60)
    strTime = Utils.formatZeroFill(time % 60) + ":" + strTime
    time = parseInt(time / 60)
    if (time > 0) {
      strTime = Utils.formatZeroFill(time) + ":" + strTime
    }
    if (duration >= 3600 && strTime.length === 5) {
      strTime = "00:" + strTime
    }
    return strTime
  }


  /**
   * Converts a time in seconds to a string and adds a zero in front of any number lower than 10.
   *
   * @param {Number} time The number to be zero filled.
   */
  static formatZeroFill(time) {
    var str = time.toString()
    if (time < 10) {
      str = "0" + str
    }
    return str
  }

  /**
   * @param {Number} number
   *    The number to be rounded.
   *
   * @param {Number} precision
   *    The level of precision. Positive 1 would round to 1 decimal place and -1 would round to the tens.
   *
   * @return {Number}
   *    The rounded number.
   */
  static round(number, precision) {
    const factor = Math.pow(10, precision)
    return Math.round(number * factor) / factor
  }

  static getEventPos(event) {
    return {
        x: (event.pageX - (window.scrollX || window.pageXOffset)) || (event.targetTouches[0].pageX - window.scrollX),
        y: (event.pageY - (window.scrollY || window.pageYOffset)) || (event.targetTouches[0].pageY - window.scrollY)
    }
  }

  static componentEnabled(plugin, component) {
    const config = plugin.config[component]
    return ((plugin.player[component] != null && plugin.player[component].enabled !== false) || (config != null && config !== false && config.enabled !== false && config.disabled !== true))
  }

  static isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }
}
